module.exports = __webpack_public_path__ + "img/iconos-soporte.77eecfa3.png";